import { useFetchClaims } from '@/hooksApi/useClaim';
import { ClaimListItem } from '@/types';

/**
 * Business-logic hook for the claims list page.
 *
 * Wraps useFetchClaims and exposes a flat, page-ready data shape so that
 * the page component never has to touch the raw API envelope.
 */
const useClaimData = (
  currentPage: number,
  pageSize: number,
  statusFilter?: string,
  typeFilter?: string,
) => {
  const { data, isFetching, isLoading, refetch } = useFetchClaims(
    currentPage,
    pageSize,
    statusFilter,
    typeFilter,
  );

  // Use isLoading (initial load only) instead of isFetching to preserve keepPreviousData
  const claims: ClaimListItem[] = data?.object?.data ?? [];
  const totals: number = data?.object?.meta?.total ?? 0;

  return {
    data: claims,
    totals,
    isFetching,
    isLoading,
    refetch,
  };
};

export default useClaimData;
